<template>
    <picture class="intrinsic" :class="ratioClass" :style="ratioStyle">
        <source v-if="medium"
                media="(min-width: 40em)"
                :srcset="medium"
        >
        <source v-if="large"
                media="(min-width: 40em)"
                :srcset="large"
        >
        <img v-if="lazyLoad" class="intrinsic-item swiper-lazy" :data-src="small" :alt="alt" :class="fitMe">
        <img v-else class="intrinsic-item" :src="small" :alt="alt" :class="fitMe">
    </picture>
</template>

<script>
	export default {
		props: [
			"floatRatio",
			"ratio",
			"alt",
			"lazyLoad",
			"small",
			"medium",
			"large",
			"width",
			"height",
            "fit"
		],
		computed: {
			ratioStyle () {
				if (this.floatRatio) {
					return {
						paddingTop: `calc(${this.floatRatio} * 100%)`
					}
                } else {
					return {};
                }
            },
			ratioClass () {
				if (this.ratio) {
					return {
						[`intrinsic--${this.ratio}`]: true
					}
                } else {
					return {};
                }
			},
            fitMe () {
				return {
					"fit-me": this.fit
                }
            }
		}
	};
</script>

<style lang="scss">
    // intrinsic.scss ------------------------
    // An Intrinsic Ratio Component
    // ---------------------------------------

    .intrinsic {

        // Make sure <picture> wrapper is set to block
        // Max-width is governed by parentNode
        display: block;

        // Intrinsic Ratio Box
        position: relative;
        height: initial;
        width: 100%;
        padding-top: 100%; // Default to square

        // Custom Styling
        background: #f0f0f0;

        /*box-shadow: 1px 1px 11px 1px rgba(0, 0, 0, 0.35);*/

        // Add as many ratios as you'd like...
        &.intrinsic--square {
            padding-top: 100%;
        }

        &.intrinsic--4x3 {
            padding-top: 75%;
        }

        &.intrinsic--16x9 {
            padding-top: 56.25%;
        }

        &.intrinsic--12x8 {
            padding-top: calc(8 / 12 * 100%);
        }

        // Force the item to fill the intrinsic box
        .intrinsic-item {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            &.fit-me {
                object-fit: cover;
                width: inherit;
                height: 100%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// intrinsic.vue?4778a87a